import "react";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
var r = (o) => /* @__PURE__ */ n("svg", {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: [
    /* @__PURE__ */ e("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.3813 6.89863L36.1463 29.2386C37.6296 31.8353 35.7546 35.067 32.7646 35.067H7.23458C4.24292 35.067 2.36792 31.8353 3.85292 29.2386L16.6179 6.89863C18.1129 4.28029 21.8863 4.28029 23.3813 6.89863Z",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ e("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 21.8667V15.6334Z"
    }),
    /* @__PURE__ */ e("path", {
      d: "M20 21.8667V15.6334",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ e("path", {
      d: "M19.9984 26.875C19.7684 26.875 19.5817 27.0616 19.5834 27.2916C19.5834 27.5216 19.77 27.7083 20 27.7083C20.23 27.7083 20.4167 27.5216 20.4167 27.2916C20.4167 27.0616 20.23 26.875 19.9984 26.875",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  ]
});
export {
  r as default
};

//# sourceMappingURL=DialogWarning.js.map